enum DateTimePeriod {
    Day = "Day",
    Week = "Week",
    Month = "Month",
    Quarter = "Quarter"
}

export default DateTimePeriod;
